/* Honest Home: official Zegsu collection marker integration.
   Uses the review app's real summary; never guesses review counts. */
(function () {
  'use strict';
  var timer = null, requested = Object.create(null);
  var shop = document.documentElement.getAttribute('data-hh-zegsu-shop');
  function populated(el) {
    return !!(el && el.querySelector('.wrapper-rating,.rating-symbol,.alr-icon-star,.zegsu-product-title-review-section'));
  }
  function count(el) {
    var m = ((el && el.textContent) || '').match(/(?:based on\s*)?([\d,]+)\s*reviews?\b/i);
    return m ? parseInt(m[1].replace(/,/g,''),10) : null;
  }
  function sync() {
    document.querySelectorAll('product-item.product-item--premium').forEach(function(card) {
      var slot = card.querySelector('.hh-card-single-rating');
      if (!slot) return;
      var marker = slot.querySelector('.zegsu-reviews-collection-marker');
      var id = slot.getAttribute('data-hh-card-rating');
      if (!marker || !id) return;
      // The official collection script exposes this function when ready.
      if (typeof window.zegsuCollectionProductSummary === 'function' && !populated(marker)) {
        try {
          var result = window.zegsuCollectionProductSummary(id);
          if (result) {
            var holder = document.createElement('div');
            if (typeof result === 'string') holder.innerHTML = result;
            else if (result.jquery && result[0]) holder.appendChild(result[0]);
            else if (result.nodeType) holder.appendChild(result);
            var generated = holder.querySelector('.zegsu-collection-stars') ||
              (holder.firstElementChild && holder.firstElementChild.classList.contains('zegsu-collection-stars') ? holder.firstElementChild : null);
            if (generated && !marker.querySelector('.zegsu-collection-stars .rating-symbol')) {
              marker.innerHTML = '';
              marker.appendChild(generated);
            }
          }
        } catch(e) { /* app may not have completed initialization */ }
      }
      // App sometimes injects stars beside rather than inside its marker.
      var all = Array.from(card.querySelectorAll('.zegsu-collection-stars'));
      var live = all.find(function(n){ return populated(n) && count(n) !== 0; }) || all.find(populated);
      if (live && live.parentElement !== marker) {
        marker.innerHTML = '';
        marker.appendChild(live);
      }
      all.forEach(function(n){ if(n !== live && live && n.isConnected) n.remove(); });
      if (live && populated(live)) {
        var liveCount = count(live);
        slot.dataset.hhRatingState = (liveCount === 0 || (liveCount === null && !/\b[1-9][0-9]*\s*reviews?\b/i.test(live.textContent || ''))) ? 'empty' : 'rated';
        return;
      }
      // Shopify standard review metafields, only when genuinely present.
      var reviews = Number(slot.dataset.hhReviewCount);
      var score = Number(slot.dataset.hhReviewScore);
      var scale = Number(slot.dataset.hhReviewScale) || 5;
      if (reviews > 0 && score > 0 && scale > 0) {
        var fallback = slot.querySelector('.hh-v92-metafield-rating');
        if (!fallback) { fallback = document.createElement('span'); fallback.className = 'hh-v92-metafield-rating'; slot.appendChild(fallback); }
        var percent = Math.max(0, Math.min(100, score / scale * 100));
        fallback.innerHTML = '<span class="hh-v92-rating-glyph" aria-hidden="true"><span class="hh-v92-rating-base">★★★★★</span><span class="hh-v92-rating-fill" style="width:'+percent+'%">★★★★★</span></span><span>Based on '+reviews+' Review'+(reviews===1?'':'s')+'</span>';
        slot.classList.add('hh-v92-use-metafield');
        slot.dataset.hhRatingState = 'rated';
      } else {
        slot.classList.remove('hh-v92-use-metafield');
        slot.dataset.hhRatingState = slot.dataset.hhReviewCount === '0' ? 'empty' : 'loading';
      }
    });
  }
  function load() {
    timer = null;
    sync();
    if (!shop) return;
    var ids = [];
    document.querySelectorAll('.hh-card-single-rating[data-hh-card-rating]').forEach(function(slot) {
      var id = slot.dataset.hhCardRating;
      if (id && !requested[id] && ids.indexOf(id) < 0) ids.push(id);
    });
    if (!ids.length) return;
    ids = ids.slice(0, 35);
    ids.forEach(function(id){ requested[id] = true; });
    var url = 'https://zegsuapps.com/shopify/reviews/collection-widget?v=2&shop=' + encodeURIComponent(shop);
    ids.forEach(function(id){ url += '&productIds[]=' + encodeURIComponent(id); });
    var script = document.createElement('script');
    script.async = true;
    script.className = 'zegsu-review-js hh-zegsu-collection-script';
    script.src = url;
    script.onload = function(){ sync(); setTimeout(sync, 350); setTimeout(sync, 1500); };
    script.onerror = function(){ ids.forEach(function(id){ delete requested[id]; }); };
    document.head.appendChild(script);
  }
  function schedule() { if(timer === null) timer = setTimeout(load, 180); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',schedule); else schedule();
  new MutationObserver(function(records) {
    if(records.some(function(r){ return Array.from(r.addedNodes).some(function(n){ return n.nodeType === 1 && n.tagName !== 'SCRIPT' && n.tagName !== 'LINK'; }); })) schedule();
  }).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',schedule);
})();
